<div *transloco="let t" class="relative">
  <button
    class="text-white bg-blue-700 hover:bg-blue-800 font-medium rounded-lg text-sm px-4 py-2.5 text-center inline-flex items-center"
    type="button"
    (pscClickOutside)="dropdownOpened = false"
    (click)="dropdownOpened = !dropdownOpened">
    <ng-content></ng-content>
    {{label}}
    <i *ngIf="!hideArrow"
       class="pvsc-icon ml-2 icon-down-arrow text-[10px]"></i>
  </button>

  <div
    class="z-10 bg-white divide-y divide-gray-100 rounded-lg shadow text-blue1 absolute mt-[3px] pt-2 right-0 font-bold"
    [style.min-width]="minOptionsWidthPx + 'px'"
    @inOutAnimation
    *ngIf="dropdownOpened"
    (click)="dropdownOpened = false">
    <div class="px-3 py-4 flex gap-2 items-center" *ngIf="header" (click)="headerClicked.emit()">
      <div *ngIf="header.icon">
        <mat-icon [fontIcon]="header.icon" class="text-4xl !w-9 !h-9 opacity-80"></mat-icon>
      </div>
      <div>
        <div>
          {{header.title}}
        </div>
        <div class="text-sm opacity-60 truncate" *ngIf="header.subtitle">
          {{header.subtitle}}
        </div>
      </div>
    </div>
    <ul class="list-none pl-0 cursor-pointer m-0">
      <li *ngFor="let option of options" (click)="optionClicked.emit(option.value)">
        <div class="{{listElementStyles}}"
             [routerLink]="option.url">
          <div class="min-w-[10px]" *ngIf="option.icon">
            <mat-icon [fontIcon]="option.icon" class="opacity-80"></mat-icon>
          </div>
            {{t(option.labelKey)}}
        </div>
      </li>
    </ul>
    <div class="cursor-pointer" *ngIf="footer" (click)="footerClicked.emit()">
      <div class="{{listElementStyles}}">
        <a [routerLink]="footer.url"
           *ngIf="footer.url">{{t(footer.labelKey)}}</a>
        <ng-container *ngIf="!footer.url">
          <div class="min-w-[10px]">
            <mat-icon *ngIf="footer.icon" [fontIcon]="footer.icon" class="opacity-80"></mat-icon>
          </div>
          {{t(footer.labelKey)}}
        </ng-container>
      </div>
    </div>
  </div>

</div>
